import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, CanActivate } from '@angular/router';
import { NgxPermissionsService } from 'ngx-permissions';
import { of } from 'rxjs/observable/of';
import { AuthDataService } from './auth-data.service';
import { UserService } from './user.service';

@Injectable()
export class PermissionGuard implements CanActivate {
    constructor(private authDataService: AuthDataService,
        private permissionsService: NgxPermissionsService,
        private userService: UserService) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        if (Object.keys(this.permissionsService.getPermissions()).length) {
            return of(true);
        } else {
            if (this.authDataService.getNavigation()) {
                this.permissionsService.loadPermissions(this.authDataService.getNavigation().permissions);
                console.log(this.permissionsService.getPermissions());
                console.log(Object.keys(this.permissionsService.getPermissions()).length);
                return true;
            } else {
                return of(false);
            }
        }
    }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/sms-server-fe-release-v2.1.8.3/src/app/services/permission.guard.ts